import type { FC } from "react";

import { DropdownMenuCheckboxItemNoIndicator } from "@/components/atoms";
import { formatTestId } from "@/utils/formatTestId";

interface BrandSubMenuProps {
  items: string[];
  selectedItems: string[];
  toggleItem: (item: string) => void;
}

const RoleSubMenu: FC<BrandSubMenuProps> = ({
  items,
  selectedItems,
  toggleItem,
}) => {
  return (
    <>
      {items.map(elem => (
        <DropdownMenuCheckboxItemNoIndicator
          key={elem}
          checked={selectedItems.includes(elem)}
          onCheckedChange={() => {
            toggleItem(elem);
          }}
          data-testid={`role-submenu-item-${formatTestId(elem)}`}
        >
          <span className="text-sm">{elem}</span>
        </DropdownMenuCheckboxItemNoIndicator>
      ))}
    </>
  );
};

export default RoleSubMenu;
